import React from 'react';
import {Provider} from "components/foreigner/ForeignerContext";
import {ForeignerList} from "components/foreigner/ForeignerList";

export const Foreigners = () => {

    return (
        <Provider>
            <ForeignerList/>
        </Provider>
    );
}
